import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';

import styled from 'styled-components';

import { getCommunityLevelFees } from 'apis/CommunityAPI';
import { useAppSelector } from 'store/hook';

import RateTrendsEditModal from './RateTrendsEditModal';
import Header from '../../common/header/Header';
import { RateTrendsInboundType } from '../types';
import { transformRateTrendsInbound } from '../utils';

const Container = styled.div`
  box-sizing: border-box;
  position: relative;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
`;

const Rates = styled.div`
  display: flex;
  padding: 15px 0px;
`;

const Text = styled.span`
  font-size: 14px;
  color: var(--text-secondary);
  margin-left: 10px;
  padding-top: 3px;
  padding-bottom: 2px;
  height: 19px;
`;

const BoldText = styled.span`
  color: var(--text-primary);
  font-family: var(--font-bold);
`;

const RateTrends = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const { competitorId } = useParams();
  const { communityId } = useParams();
  const id = Number(competitorId || communityId);

  const [rateTrends, setRateTrends] = useState<RateTrendsInboundType | undefined>(undefined);

  const { isSuccess, refetch } = useQuery({
    queryKey: ['community', 'rate', 'trends', id],
    queryFn: () => getCommunityLevelFees(id, { active: 1 }),
    onSuccess: (data) => {
      const dataEntry = data.length > 0 ? data[0] : undefined;
      const hasBothValues =
        Boolean(dataEntry?.annual_rate_increase_min) && Boolean(dataEntry?.annual_rate_increase_max);
      setRateTrends(hasBothValues ? transformRateTrendsInbound(dataEntry) : undefined);
    },
    enabled: Boolean(id),
  });

  const showEditButton = !competitorId && isSuccess && currentUser?.isSuperuser;

  return (
    <Container>
      <Header
        title="Rate Trends"
        controls={
          <RateTrendsEditModal
            type={'button'}
            show={showEditButton}
            buttonDataTestId="cd-edit-rate-trends-btn"
            onSuccess={refetch}
          />
        }
      />
      <Content>
        {rateTrends && (
          <Rates>
            <img src="/icons/rate-trends.svg" alt="rate trends" height="24px" width="24px" />
            <Text>
              The rates tend to
              <BoldText>{` increase between ${rateTrends.annualRateRncreaseMin}% and ${rateTrends.annualRateRncreaseMax}% `}</BoldText>
              each year.
            </Text>
          </Rates>
        )}
        {!rateTrends && (
          <RateTrendsEditModal
            type={'link'}
            show={showEditButton}
            linkDataTestId="cd-add-rate-trends-link"
            onSuccess={refetch}
          />
        )}
      </Content>
    </Container>
  );
};

export default RateTrends;
